import axios from "axios";

import { LMS_BASE_URL } from "../../../../utils/http/http-common";
import { LMS_TOKEN } from "../../../../utils/cookiesmanager";

export const getPostModuleAssessmentQuestionApiCall = async (args) => {
    const {courseId, moduleId , languageid = 1} = args;

    const authToken = localStorage.getItem(LMS_TOKEN);

    try {
    const response = await axios.get(
      `${LMS_BASE_URL}/course/module-assessment-questions?courseId=${courseId}&moduleId=${moduleId}&languageid=${languageid}`,{
        headers:{
            Authorization:`Bearer ${authToken}`
        }
      }
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};

export const savePostModuleAssessment = async (payload) => {
    const authToken = localStorage.getItem(LMS_TOKEN);
    try {
    const response = await axios.post(
      `${LMS_BASE_URL}/course/module/post-assessment`, payload ,{
        headers:{
            Authorization:`Bearer ${authToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};